import React, { useCallback, useEffect, useState } from "react";
import "../leaveHistory.css";
import DashboardGreeting from "../DashboardGreeting";
import { Calendar as MonthCalendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useStateContext } from "../../contexts/ContextProvider";
import AuthService from "../../services/auth.service";
import DashboardService from "../../services/dashboard.service";
import CommonLeaveOverview from "../common/CommonLeaveOverview";
import EmpDashboardStats from "../Employee/EmpDashboardStats";
import LeaveHistoryService from "../../services/leaveHistory.service";
import DataTable from "react-data-table-component";
import CommonService from "../../services/common.service";

const EmpLeaveHistory = () => {
  const navHeading = "Employee Leave History";

  const [date, setDate] = useState(new Date());

  const [year, setYear] = useState("");

  const [tabIndex, setTabIndex] = useState(0);

  const user = AuthService.getCurrentUser();

  const location = useLocation();

  const { rowData, redirectBack } = location.state || {};

  const [leaveData, setLeaveData] = useState({
    lop: "0",
    paidleave: "0",
    goodwill: "0",
    totalTakenLeaves: "0",
    yealrlyBalanceLeaves: "0",
    totalPaidTakenLeaves: "0",
    yearlyAllocatedleaves: "0",
    queterBalance: "0",
  });

  const [empData, setEmpData] = useState({});

  const fetchEmpLeaveOverview = (currentYear) => {
    const payload = {
      empId:
        user.role === "1"
          ? rowData && rowData.empId
          : user.role === "2" && location.pathname === "empLeaveHistory"
          ? rowData.rowData.empid
          : user && user.empid,
      year: currentYear.toString(),
    };

    DashboardService.getEmpLeaveOverview(payload)
      .then((resp) => {
        setLeaveData(resp.data);
      })
      .catch((e) => console.log(e));
  };

  const fetchEmpDataEdit = (empId) => {
    const payload = {
      EmpId: empId,
    };
    CommonService.getEmpDetailsForUpd(payload)
      .then((resp) => {
        if (resp.data) {
          setEmpData(resp.data[0]);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    const empid =
      user.role === "1" || user.role === "4" ? rowData.empId : rowData.empid;
    fetchEmpDataEdit(empid);
  }, [rowData]);

  useEffect(() => {
    const currentYear = moment(new Date()).format("YYYY");
    if (currentYear) {
      fetchEmpLeaveOverview(currentYear);
    }
  }, []);

  const handleDateChange = (e) => {
    setDate(e.value);
    const x = moment(new Date(e.value)).format("YYYY");
    // console.log(x);
    setYear(x);
    fetchEmpLeaveOverview(x);
  };

  const {
    windowHeight,
    setWindowHeight,
  } = useStateContext();

  const columns = [
    {
      name: "Leave Reason",
      selector: (row) => row.leaveReason,
      cell: (row) => (
        <>
          <span title={`${row.leaveReason}`}>{`${row.leaveReason}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "From",
      selector: (row) => row.fromDate,
      cell: (row) => (
        <>
          <span title={`${row.fromDate}`}>{`${moment(
            row.fromDate,
            "DD/MM/YY"
          ).format("D MMMM, YYYY")}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "To",
      selector: (row) => row.toDate,
      cell: (row) => (
        <>
          <span title={`${row.toDate}`}>{`${moment(
            row.toDate,
            "DD/MM/YY"
          ).format("D MMMM, YYYY")}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Duration",
      selector: (row) => row.leavedays,
      cell: (row) => (
        <>
          <span title={`${row.leavedays}`}>{`${row.leavedays}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "DOR",
      selector: (row) => row.dor,
      cell: (row) => (
        <>
          <span title={`${row.dor}`}>{`${row.dor}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "RM Approval",
      selector: (row) => row.rmActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.rmActionsts === "0" ? "status pending" : "status approved"
            }`}
          >
            <span
              title={`${row.rmActionsts === "0" ? "Pending" : "Approved"}`}
            >{`${row.rmActionsts === "0" ? "Pending" : "Approved"}`}</span>
          </div>
        </>
      ),
      sortable: true,
      omit: user.role === "2",
    },
    {
      name: "HR Approval",
      selector: (row) => row.hrActionsts,
      cell: (row) => (
        <>
          <div
            className={`${
              row.hrActionsts === "0"
                ? "status pending"
                : row.hrActionsts === "2"
                ? "status rejected"
                : "status approved"
            }`}
          >
            <span
              title={`${
                row.hrActionsts === "0"
                  ? "Pending"
                  : row.hrActionsts === "2"
                  ? "Rejected"
                  : "Approved"
              }`}
            >{`${
              row.hrActionsts === "0"
                ? "Pending"
                : row.hrActionsts === "2"
                ? "Rejected"
                : "Approved"
            }`}</span>
          </div>
        </>
      ),
      sortable: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => row.actionStatusHR,
    //   cell: (row) => (
    //     <>
    //       <LeaveApplicationAction
    //         setEditLeaveModal={setEditLeaveModal}
    //         setDeleteLeaveModal={setDeleteLeaveModal}
    //         setSelectedData={setSelectedData}
    //         rowData={row}
    //         leaveCat={leaveCat}
    //       />
    //     </>
    //   ),
    //   sortable: true,
    // },
  ];

  const [data, setData] = useState([]);

  const fetchData = useCallback(() => {
    const payload = {
      emp_id:  user.role === "1"
          ? rowData && rowData.empId
          : user.role === "2" && location.pathname === "empLeaveHistory"
          ? rowData.rowData.empid
          : user && user.empid,
    };

    LeaveHistoryService.getLeaveRequest(payload)
      .then((response) => {
        if (response.data) {
          setData(response.data);
        }
      })
      .catch((e) => {
         console.log(e);
         setData([]);
      });
  }, [user.empid]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let h = window.innerHeight;
    // console.log("height", h);
    setWindowHeight(h - 150);
  });

  return (
    <>
      <div className="dashboard-container leaveDetails">
        <DashboardGreeting
          navHeading={navHeading}
          redirectBack={redirectBack}
          user={user}
          rowData={rowData}
        />
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
          <div className="topbar-flex mb-3">
            <div className="statusTabs2">
              <TabList>
                <Tab
                  className={
                    tabIndex === 0
                      ? "react-tabs__tab active"
                      : "react-tabs__tab"
                  }
                >
                  Leave History
                </Tab>
                <Tab
                  className={
                    tabIndex === 1
                      ? "react-tabs__tab active"
                      : "react-tabs__tab"
                  }
                >
                  Basic Details & Yearly Overview
                </Tab>
              </TabList>
            </div>
            {tabIndex === 0 ? (
              <>
                <></>
              </>
            ) : (
              <>
                <div className="flex">
                  <div className="filterBar mb-5">
                    <div className="filter">
                      <div className="month-filter">
                        <MonthCalendar
                          value={date}
                          onChange={handleDateChange}
                          view="year"
                          dateFormat="yy"
                          style={{ height: "45px" }}
                          showIcon
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <TabPanel>
            <div className="scroll" style={{ height: windowHeight }}>
              <div className="emp-stats">
                <EmpDashboardStats rowData={rowData} />
                <div className="recent-leave">
                  <div className="d-flex mb-3">
                    <div className="heading arrow-flex">
                      <span>Recently Applied Leaves</span>
                    </div>
                  </div>
                  <div className="list list2">
                    <DataTable columns={columns} data={data} />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            {rowData && (
              <>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="emp-info2">
                      <div className="emp-profile">
                        {empData.empProfilePicName !== "" ? (
                          <>
                            {" "}
                            <div className="circle">
                              <img
                                src={`https://elmsbk.aeontechhub.com/ProfilePic/${empData.empId}/${empData.empProfilePicName}`}
                                width="100px"
                                alt=""
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            {empData.gender === "Male" ? (
                              <>
                                <img
                                  src="https://avatar.iran.liara.run/public/boy"
                                  width="100px"
                                  alt=""
                                />
                              </>
                            ) : (
                              <>
                                <img
                                  src="https://avatar.iran.liara.run/public/girl"
                                  width="100px"
                                  alt=""
                                />
                              </>
                            )}
                          </>
                        )}

                        <div className="profile-flex">
                          <span className="name">{empData.name}</span>
                          <span className="code">ID: {empData.empId}</span>
                          <span className="desig">{empData.designation}</span>
                        </div>
                      </div>
                      <div
                        className="emp-details scroll"
                        style={{ height: windowHeight - 215 }}
                      >
                        <div className="flex">
                          <div className="flex1">
                            <span>
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.9987 24.5C18.082 20.3 22.1654 16.5391 22.1654 11.9C22.1654 7.26081 18.509 3.5 13.9987 3.5C9.48837 3.5 5.83203 7.26081 5.83203 11.9C5.83203 16.5391 9.91536 20.3 13.9987 24.5Z"
                                  stroke="#988DAA"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M14 15.1667C15.933 15.1667 17.5 13.5998 17.5 11.6667C17.5 9.73376 15.933 8.16675 14 8.16675C12.0669 8.16675 10.5 9.73376 10.5 11.6667C10.5 13.5998 12.0669 15.1667 14 15.1667Z"
                                  stroke="#988DAA"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                            <span>Address</span>
                          </div>
                          <span>{empData.address}</span>
                        </div>
                        <div className="flex">
                          <div className="flex1">
                            <span>
                              <svg
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21.875 8.33325L18.1658 10.3939C16.0979 11.5427 15.064 12.1172 13.969 12.3424C12.9998 12.5417 12.0002 12.5417 11.031 12.3424C9.93608 12.1172 8.90211 11.5427 6.83417 10.3939L3.125 8.33325M6.45833 19.7916H18.5417C19.7084 19.7916 20.2919 19.7916 20.7375 19.5645C21.1295 19.3648 21.4482 19.0461 21.6479 18.6541C21.875 18.2085 21.875 17.625 21.875 16.4583V8.54159C21.875 7.37481 21.875 6.79142 21.6479 6.34577C21.4482 5.95376 21.1295 5.63505 20.7375 5.43532C20.2919 5.20825 19.7084 5.20825 18.5417 5.20825H6.45833C5.29156 5.20825 4.70817 5.20825 4.26252 5.43532C3.87051 5.63505 3.5518 5.95376 3.35207 6.34577C3.125 6.79142 3.125 7.3748 3.125 8.54159V16.4583C3.125 17.625 3.125 18.2085 3.35207 18.6541C3.5518 19.0461 3.87051 19.3648 4.26252 19.5645C4.70817 19.7916 5.29155 19.7916 6.45833 19.7916Z"
                                  stroke="#988DAA"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                            <span>Mail ID</span>
                          </div>
                          <span>{empData.email}</span>
                        </div>
                        <div className="flex">
                          <div className="flex1">
                            <span>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clip-rule="evenodd"
                                  d="M17.355 22.2322C15.3349 21.7261 11.1994 20.2992 7.45025 16.5501C3.70114 12.801 2.27429 8.66553 1.76816 6.64544C1.4773 5.48453 2.00107 4.36428 2.88918 3.72991L5.21743 2.06687C6.57971 1.09382 8.47481 1.42401 9.42773 2.80045L10.8935 4.9177C11.5157 5.81644 11.3011 7.04824 10.4116 7.68359L9.24283 8.51843C9.41972 9.19504 9.96988 10.5845 11.6929 12.3075C13.4159 14.0305 14.8054 14.5806 15.482 14.7575L16.3168 13.5887C16.9522 12.6993 18.184 12.4846 19.0827 13.1068L21.2 14.5726C22.5764 15.5256 22.9066 17.4206 21.9335 18.7829L20.2705 21.1112C19.6361 21.9993 18.5159 22.5231 17.355 22.2322ZM8.86446 15.1359C12.2739 18.5453 16.0363 19.84 17.841 20.2922C18.1048 20.3582 18.4237 20.2557 18.643 19.9487L20.3061 17.6204C20.6304 17.1664 20.5204 16.5347 20.0615 16.217L17.9443 14.7512L17.0484 16.0055C16.6823 16.5181 16.0052 16.9201 15.2168 16.75C14.2328 16.5377 12.4138 15.8568 10.2787 13.7217C8.14359 11.5866 7.46268 9.76764 7.25036 8.78364C7.08026 7.99524 7.4823 7.31815 7.99488 6.95202L9.24913 6.05612L7.78334 3.93887C7.4657 3.48005 6.834 3.36999 6.37991 3.69434L4.05166 5.35738C3.74462 5.57669 3.64211 5.89559 3.7082 6.15937C4.16038 7.96412 5.45508 11.7265 8.86446 15.1359Z"
                                  fill="#988DAA"
                                />
                              </svg>
                            </span>
                            <span>Contact No</span>
                          </div>
                          <span>{empData.mobileno}</span>
                        </div>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="flex">
                              <div className="flex1">
                                <span>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M22.7347 9.6084C22.5667 8.90665 21.8212 8.65902 21.2218 8.42802C21.1728 8.40965 21.1177 8.40177 21.0617 8.40177C21.0538 8.40177 21.0459 8.4044 21.038 8.40527C21.0267 8.37902 21.0162 8.3519 21.0048 8.32565C20.8788 8.03515 20.7195 7.7499 20.5375 7.49002C20.079 6.8329 19.5015 6.23527 18.8567 5.75927C18.245 5.30602 17.5267 5.0549 16.8293 4.76615C16.5738 4.66027 16.3087 4.5719 16.04 4.49315C16.0479 4.48002 16.0549 4.46777 16.0628 4.45465C16.2623 4.13352 16.4705 3.82377 16.7304 3.54902C16.9282 3.38365 17.1408 3.23665 17.3482 3.0809C17.5284 2.9444 17.713 2.82452 17.9055 2.71165C18.1899 2.56465 18.483 2.43427 18.7902 2.34327C18.9914 2.30215 19.1927 2.27065 19.3974 2.2654C19.5243 2.27765 19.6503 2.29515 19.7745 2.32227C19.7982 2.33277 19.8218 2.34327 19.8454 2.35465C19.8787 2.3809 19.911 2.40715 19.9417 2.43602C19.9872 2.49115 20.0283 2.54627 20.0668 2.60577C20.0887 2.65915 20.107 2.71252 20.1245 2.76677C20.1298 2.80177 20.1333 2.8359 20.1359 2.8709C20.1342 2.87965 20.1333 2.8884 20.1315 2.89627C20.1175 2.93302 20.1035 2.9689 20.0869 3.00477C20.0747 3.02052 20.0624 3.03627 20.0502 3.05115C19.9968 3.09402 19.9417 3.13427 19.8839 3.17277C19.8288 3.19815 19.7737 3.22177 19.7159 3.2419C19.6835 3.24627 19.6512 3.24977 19.6188 3.2524C19.596 3.24977 19.5742 3.2454 19.5514 3.2419C19.5505 3.24102 19.5488 3.24102 19.5479 3.24015C19.5103 3.20952 19.4744 3.17627 19.4403 3.14127C19.3405 3.0634 19.2294 3.01352 19.1043 2.99252C18.9118 2.96102 18.7123 3.00915 18.5565 3.12552C18.2389 3.35915 18.1689 3.8229 18.4052 4.13965C18.4874 4.2499 18.5828 4.34965 18.6852 4.44152C18.8444 4.5859 19.0597 4.66115 19.2618 4.71802C19.6407 4.82827 20.0799 4.7679 20.4334 4.59377C20.7055 4.4599 20.9575 4.29715 21.1597 4.06615C21.4939 3.6864 21.6654 3.13602 21.5718 2.63465C21.4432 1.92327 20.9497 1.29502 20.2707 1.03252C19.8515 0.871523 19.3685 0.850523 18.9275 0.904773C18.5959 0.945023 18.2643 1.02115 17.9502 1.1419C17.9248 1.15152 17.8994 1.16202 17.8749 1.17165C17.5459 1.3099 17.2274 1.49802 16.922 1.6844C16.7672 1.7789 16.6228 1.8909 16.4767 1.99765C16.3314 2.10265 16.1827 2.20415 16.0427 2.31615C15.7137 2.57602 15.4442 2.88752 15.1939 3.2209C14.9533 3.53852 14.7477 3.88065 14.5403 4.22102C14.4178 4.21402 14.2962 4.21052 14.1737 4.21052C13.926 4.21052 13.6793 4.22365 13.4308 4.2429C13.023 4.27702 12.6127 4.32777 12.2198 4.44502C11.469 4.66902 10.7358 4.96477 10.0787 5.38915C9.74616 5.60527 9.46354 5.88527 9.18354 6.16352C8.89654 6.44877 8.65329 6.78127 8.41791 7.1094C8.07141 7.59065 7.77829 8.12527 7.56479 8.68615C7.01616 8.74477 6.47454 8.8839 6.04666 9.25315C5.82441 9.44652 5.64941 9.69677 5.49804 9.94965C5.31779 10.255 5.20754 10.612 5.19616 10.9673C5.18391 11.2744 5.30641 11.5596 5.42366 11.8353C5.55754 12.1494 5.79204 12.404 6.06066 12.6079C6.44391 12.8975 6.90066 13.0524 7.37054 13.1101C7.38104 13.1224 7.38279 13.1399 7.39504 13.1521C7.44579 13.216 7.50266 13.2755 7.55429 13.3403C7.50266 13.4409 7.46591 13.5503 7.46066 13.6701C7.43004 14.3999 7.35916 15.1262 7.26991 15.8506C7.19466 16.408 7.12991 16.9645 7.10104 17.5272C7.07216 18.1082 7.07041 18.6856 7.08266 19.2675C7.09754 19.9387 7.16054 20.594 7.26291 21.2582C7.35129 21.8322 7.56741 22.3825 7.79141 22.918C7.87716 23.1254 7.96116 23.3337 8.07141 23.5288C8.17466 23.7143 8.28666 23.8937 8.40129 24.0722C8.61041 24.4029 8.82916 24.7258 9.07679 25.0303C9.19054 25.1694 9.30954 25.3033 9.43379 25.4345C9.65254 25.669 9.92991 25.8572 10.2029 26.0234C10.5337 26.2238 10.8723 26.4224 11.2205 26.5904C11.4209 26.6875 11.6335 26.7689 11.8418 26.8433C12.0098 26.9045 12.1778 26.9719 12.351 27.0095C12.582 27.0603 12.8183 27.0857 13.0528 27.1032C13.2208 27.1172 13.3905 27.1303 13.5603 27.125C13.9339 27.111 14.3075 27.0655 14.6829 27.0585C15.0784 27.0498 15.4538 26.9465 15.8362 26.8459C16.1792 26.754 16.5152 26.6438 16.8582 26.5502C17.2082 26.453 17.5223 26.2815 17.8277 26.0917C17.9773 25.998 18.1182 25.886 18.2573 25.781C18.4472 25.6384 18.6545 25.4993 18.8243 25.3313C19.1314 25.0285 19.3878 24.6829 19.6363 24.3329C19.8515 24.0293 20.037 23.7064 20.2033 23.3748C20.3932 22.9942 20.5227 22.5855 20.6452 22.1778C20.8779 21.3999 21.0529 20.6001 21.1343 19.7917C21.2314 18.844 21.3469 17.8745 21.2498 16.9234C21.2008 16.436 21.129 15.9487 21.0135 15.4727C20.9173 15.0842 20.7677 14.7105 20.6128 14.3404C20.5332 14.1383 20.4737 13.93 20.4028 13.7244C20.3835 13.6684 20.3485 13.622 20.3197 13.573C20.415 13.4418 20.5043 13.307 20.5822 13.1661C20.6942 12.9623 20.7843 12.7479 20.8744 12.5344C20.9217 12.5195 20.9698 12.5116 21.0162 12.4941C21.2148 12.4163 21.4003 12.3279 21.5779 12.2124C21.9314 11.9849 22.2079 11.6454 22.4573 11.3138C22.6883 11.0066 22.8143 10.6138 22.8073 10.2305C22.8003 10.024 22.7819 9.80877 22.7347 9.6084ZM21.423 9.94615C21.423 9.94702 21.423 9.94702 21.423 9.9479C21.4169 9.93915 21.4099 9.93127 21.4038 9.92252C21.4108 9.9304 21.4178 9.93827 21.423 9.94615ZM10.6833 24.5123C10.4409 24.3023 10.237 24.0564 10.0375 23.8062C9.67529 23.3249 9.34016 22.8305 9.08904 22.2819C8.98754 22.0387 8.88954 21.7945 8.80554 21.5443C8.70754 21.2503 8.64804 20.9536 8.59991 20.6518C8.51416 19.8949 8.50191 19.1389 8.49841 18.3785C8.49404 17.6645 8.54829 16.9514 8.63316 16.2427C8.71016 15.6888 8.78716 15.134 8.85191 14.5784C8.85716 14.5819 8.86241 14.5863 8.86766 14.5898C9.10916 14.7446 9.34979 14.9057 9.60616 15.036C9.87216 15.1725 10.1417 15.2915 10.4155 15.407C10.7297 15.5558 11.0324 15.7229 11.35 15.8629C11.7202 16.0257 12.0955 16.1648 12.4893 16.2567C13.1893 16.4212 13.9392 16.4894 14.6575 16.4316C14.7415 16.4246 14.8247 16.4098 14.9087 16.401C14.8789 16.835 14.8518 17.269 14.8422 17.7065C14.8317 18.207 14.7888 18.7032 14.7284 19.2002C14.654 19.6788 14.5604 20.153 14.4484 20.6246C14.3399 21.0831 14.1877 21.5242 14.0153 21.9608C13.7747 22.4954 13.4912 23.002 13.1902 23.5069C12.8874 24.0161 12.5742 24.5236 12.2285 25.0058C12.1515 25.1012 12.0649 25.1834 11.9792 25.2683C11.7945 25.1755 11.6108 25.0828 11.4314 24.9778C11.1759 24.8299 10.9239 24.682 10.6833 24.5123ZM19.7133 18.4205C19.6984 18.7128 19.666 19.0033 19.6372 19.2938C19.6118 19.5458 19.5917 19.7987 19.5619 20.0498C19.4832 20.5004 19.379 20.9475 19.2618 21.3894C19.1533 21.7998 19.0308 22.2066 18.8759 22.6021C18.6554 23.0624 18.3868 23.4903 18.0858 23.8998C17.9108 24.1106 17.7253 24.3014 17.5118 24.4747C17.2134 24.7004 16.9098 24.927 16.5738 25.0907C16.0217 25.284 15.4468 25.459 14.8693 25.5597C14.5394 25.5938 14.2087 25.6052 13.877 25.6192C13.7213 25.6253 13.5682 25.6095 13.415 25.6052C13.5655 25.3882 13.7152 25.1703 13.8604 24.9498C14.2524 24.3504 14.6488 23.737 14.9647 23.0939C15.3059 22.4044 15.5877 21.6895 15.7732 20.9423C15.963 20.1732 16.1013 19.3918 16.1905 18.6034C16.2833 17.7835 16.3358 16.9593 16.4145 16.1394C16.5108 16.114 16.6088 16.1009 16.7042 16.072C17.09 15.9548 17.4584 15.8174 17.8268 15.6564C18.1374 15.5208 18.4463 15.3781 18.7184 15.1725C18.8654 15.0605 19.001 14.938 19.1402 14.819C19.2067 15.0115 19.2802 15.2014 19.3423 15.3948C19.4893 15.8541 19.6004 16.3188 19.673 16.7939C19.7317 17.3355 19.7439 17.8745 19.7133 18.4205ZM21.423 10.3023C21.3872 10.3731 21.3469 10.4405 21.3023 10.5061C21.1474 10.6925 20.9812 10.8754 20.8 11.0355C20.7379 11.0758 20.674 11.1125 20.6084 11.1458C20.4973 11.1825 20.3862 11.2105 20.2715 11.2315C20.2505 11.2341 20.2304 11.2359 20.2103 11.2376C20.0134 11.256 19.8489 11.3024 19.7045 11.4468C19.5724 11.5806 19.4954 11.7644 19.4954 11.9525C19.4954 11.9718 19.505 11.9893 19.5068 12.0076C19.4753 12.0811 19.4412 12.1538 19.4105 12.2273C19.2959 12.4723 19.1542 12.6971 18.9932 12.9141C18.8427 13.1005 18.6878 13.2825 18.5285 13.4584C18.3422 13.6631 18.1252 13.8504 17.9082 14.0263C17.6255 14.224 17.3184 14.3728 17.0043 14.5136C16.362 14.7709 15.6804 14.9468 14.9962 15.0518C14.7293 15.0841 14.4615 15.1078 14.1912 15.1122C13.9059 15.1165 13.618 15.0938 13.3345 15.0623C12.9154 14.994 12.5112 14.8846 12.1157 14.7324C11.8987 14.637 11.6825 14.5355 11.4708 14.4296C11.1908 14.2905 10.9117 14.1628 10.6247 14.042C10.6789 14.0639 10.7314 14.0875 10.7857 14.1103C10.3079 13.8898 9.86604 13.6168 9.44166 13.3096C9.30079 13.1871 9.16866 13.0603 9.04354 12.9211C8.95341 12.8214 8.87029 12.7155 8.78804 12.6088C8.70229 12.4959 8.61829 12.3848 8.53254 12.2719C8.44679 12.1599 8.35229 12.0776 8.24029 12.0129C8.12479 11.9079 7.97429 11.8396 7.80804 11.837C7.72141 11.8361 7.63654 11.8318 7.55166 11.8239C7.42566 11.8011 7.30579 11.7696 7.18504 11.7268C7.08179 11.6769 6.98554 11.6218 6.89016 11.557C6.84116 11.5133 6.79479 11.4686 6.75104 11.4205C6.71779 11.3689 6.68716 11.3173 6.66004 11.2621C6.62941 11.179 6.60316 11.095 6.58304 11.0084C6.58216 10.9891 6.58216 10.969 6.58216 10.9498C6.59616 10.885 6.61454 10.822 6.63554 10.7581C6.68454 10.6601 6.74054 10.5674 6.80266 10.4773C6.85341 10.4178 6.90679 10.36 6.96454 10.3066C7.00391 10.2821 7.04329 10.2594 7.08441 10.2384C7.12904 10.2226 7.17629 10.2174 7.22091 10.2043C7.19116 10.6076 7.58316 10.9463 7.96291 10.9463C8.38729 10.9463 8.68129 10.6068 8.70666 10.2025C8.71191 10.1141 8.71979 10.0258 8.72766 9.9374C8.78804 9.59352 8.87641 9.26015 9.00329 8.93202C9.22116 8.4534 9.50729 8.0054 9.81704 7.5819C10.0612 7.27827 10.3289 6.98077 10.6273 6.72965C10.9152 6.52665 11.2197 6.35165 11.539 6.20377C12.015 6.01915 12.5033 5.85552 13.0082 5.77152C13.6373 5.70765 14.2629 5.68315 14.892 5.74965C15.2972 5.82227 15.6988 5.9229 16.0855 6.06727C16.3095 6.16527 16.5327 6.26327 16.7575 6.35952C17.1705 6.54152 17.58 6.72965 17.9502 6.9904C18.3177 7.29577 18.6414 7.64665 18.9485 8.01327C19.2714 8.46915 19.5269 8.9714 19.75 9.4824C19.7763 9.5489 19.8017 9.6154 19.8262 9.68365C19.8944 9.88227 20.0029 10.0468 20.1875 10.1561C20.3695 10.2611 20.5918 10.29 20.7939 10.234C21.0083 10.1754 21.1667 10.0389 21.262 9.86652C21.3014 9.8884 21.3434 9.90327 21.381 9.9269C21.3977 9.94177 21.4134 9.95665 21.4292 9.97152C21.4353 10.073 21.4353 10.1728 21.43 10.2734C21.4283 10.2856 21.4257 10.2935 21.423 10.3023ZM21.4572 10.0021C21.4572 10.003 21.458 10.003 21.4572 10.0021C21.4633 10.0153 21.4694 10.0284 21.4738 10.0424C21.4685 10.0293 21.4633 10.0161 21.4572 10.0021ZM12.701 10.0494C12.701 10.4519 12.365 10.7879 11.9625 10.7879C11.56 10.7879 11.224 10.4519 11.224 10.0494C11.224 9.6469 11.56 9.3109 11.9625 9.3109C12.3642 9.3109 12.701 9.6469 12.701 10.0494ZM16.5003 10.1684C16.5003 10.5709 16.1643 10.9069 15.7618 10.9069C15.3593 10.9069 15.0233 10.5709 15.0233 10.1684C15.0233 9.7659 15.3593 9.4299 15.7618 9.4299C16.1634 9.42902 16.5003 9.7659 16.5003 10.1684ZM7.77829 22.89C7.78179 22.8988 7.78616 22.9075 7.79054 22.9163C7.80191 22.9434 7.81241 22.9705 7.82379 22.9968C7.80804 22.9618 7.79229 22.9259 7.77829 22.89Z"
                                      fill="#988DAA"
                                    />
                                  </svg>
                                </span>
                                <span>DOB</span>
                              </div>
                              <span>
                                {empData.dob !== "" && (
                                  <>
                                    {" "}
                                    {moment(empData.dob, "YYYY-MM-DD").format(
                                      "D MMM YYYY"
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="flex">
                              <div className="flex1">
                                <span>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M20.5 15V10C20.5 7.17157 20.5 5.75736 19.6213 4.87868C18.7426 4 17.3284 4 14.5 4H9.5C6.67157 4 5.25736 4 4.37868 4.87868C3.5 5.75736 3.5 7.17157 3.5 10V15"
                                      stroke="#988DAA"
                                      stroke-width="1.8"
                                    />
                                    <path
                                      d="M5 20H19C20.6569 20 22 18.6569 22 17V16C22 15.4477 21.5523 15 21 15H16.6667C16.2339 15 15.8129 15.1404 15.4667 15.4L14.5333 16.1C14.1871 16.3596 13.7661 16.5 13.3333 16.5H10.6667C10.2339 16.5 9.81286 16.3596 9.46667 16.1L8.53333 15.4C8.18714 15.1404 7.76607 15 7.33333 15H3C2.44772 15 2 15.4477 2 16V17C2 18.6569 3.34315 20 5 20Z"
                                      stroke="#988DAA"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                </span>
                                <span>DOJ</span>
                              </div>
                              <span>
                                {empData.joiningdate !== "" && (
                                  <>
                                    {" "}
                                    {moment(
                                      empData.joiningdate,
                                      "YYYY-MM-DD"
                                    ).format("D MMM YYYY")}
                                  </>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex">
                          <div className="flex1">
                            <span>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_243_5796)">
                                  <path
                                    d="M7.49428 21.3104C9.18641 21.3104 10.7444 20.7397 12 19.7903C13.256 20.7402 14.8136 21.3104 16.5057 21.3104C20.6384 21.3104 24 17.9489 24 13.8165C24 9.68383 20.6385 6.32227 16.5057 6.32227C14.8136 6.32227 13.2556 6.89291 12 7.84232C10.744 6.89248 9.18641 6.32227 7.49428 6.32227C3.36156 6.32231 0 9.68383 0 13.8165C0 17.9484 3.36156 21.3104 7.49428 21.3104ZM12 10.7884C12.5838 11.6541 12.925 12.6963 12.925 13.8165C12.925 14.9368 12.5838 15.979 12 16.8447C11.4161 15.979 11.0749 14.9368 11.0749 13.8165C11.0749 12.6963 11.4166 11.6541 12 10.7884ZM16.5061 8.38535C19.5009 8.38535 21.9373 10.8218 21.9373 13.8165C21.9373 16.8113 19.5009 19.2473 16.5061 19.2473C15.383 19.2473 14.3383 18.9045 13.4714 18.3181C14.4191 17.0629 14.9885 15.507 14.9885 13.8165C14.9885 12.1261 14.4191 10.5697 13.4714 9.31456C14.3383 8.72821 15.383 8.38535 16.5061 8.38535ZM7.49428 8.38535C8.6174 8.38535 9.66213 8.72821 10.529 9.31456C9.58126 10.5697 9.01187 12.1261 9.01187 13.8165C9.01187 15.507 9.58126 17.0629 10.529 18.3181C9.66213 18.9045 8.6174 19.2473 7.49428 19.2473C4.49957 19.2473 2.06308 16.8113 2.06308 13.8165C2.06304 10.8218 4.49953 8.38535 7.49428 8.38535Z"
                                    fill="#988DAA"
                                  />
                                  <path
                                    d="M11.8563 3.36007H11.8481C11.8481 3.36007 10.7076 2.11108 9.71235 3.02338C8.71712 3.93568 9.58774 6.0375 11.8481 6.9498L11.8563 6.95765C14.1162 6.04536 14.9872 3.93568 13.9919 3.02342C12.9968 2.11108 11.8563 3.36007 11.8563 3.36007Z"
                                    fill="#988DAA"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_243_5796">
                                    <rect width="24" height="24" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span>Marital Status</span>
                          </div>
                          <span>{empData.maritial_Status}</span>
                        </div>
                        <div className="flex">
                          <div className="flex1">
                            <span>
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.6459 9.35395C13.9709 8.67648 13.1491 8.1412 12.2354 7.79372C11.804 8.27311 11.5103 8.85673 11.3876 9.48957C11.3543 9.6602 11.3343 9.83126 11.3251 10.0015C11.4002 10.0273 11.4736 10.0549 11.5454 10.0862C12.3414 10.4236 13.0248 10.9886 13.5037 11.7003C13.8883 12.2693 14.1436 12.9281 14.2296 13.6419C14.2521 13.82 14.2629 14.0015 14.2629 14.1867C14.2629 14.805 14.1386 15.3875 13.9142 15.9189C13.6355 16.5743 13.2041 17.1542 12.6626 17.6052C12.5475 17.7024 12.4265 17.7926 12.3014 17.8772C11.5897 18.3578 10.7402 18.6365 9.81324 18.6365C9.19664 18.6365 8.61509 18.5118 8.08276 18.2877C7.28509 17.9502 6.60423 17.3849 6.12364 16.6736C5.64469 15.9631 5.366 15.1117 5.366 14.1867C5.366 13.5689 5.48866 12.9873 5.71392 12.4546C6.01683 11.7395 6.50492 11.1154 7.11819 10.6494C7.10648 10.4879 7.10145 10.3265 7.10145 10.1651C7.10145 9.33574 7.23161 8.52636 7.47945 7.76123C6.53073 8.10625 5.67969 8.65482 4.98215 9.35406C3.74561 10.5869 2.97796 12.3028 2.98047 14.1868C2.97801 16.0713 3.74566 17.7871 4.98215 19.0203C6.01175 20.0516 7.3768 20.7537 8.89537 20.9577V23.0879H5.7289V24.9227H8.89537V27.9998H10.731V24.9226H13.9V23.0878H10.731V20.9577C12.2504 20.7537 13.6171 20.0515 14.6459 19.0203C14.9897 18.6765 15.2959 18.2969 15.562 17.886C16.2504 16.8201 16.6501 15.5464 16.6484 14.1867C16.6484 13.8676 16.6259 13.5518 16.5842 13.2439C16.3748 11.7336 15.6722 10.3778 14.6459 9.35395Z"
                                  fill="#988DAA"
                                />
                                <path
                                  d="M19.0875 0V1.83482H21.8877L18.9941 4.72845C17.7758 3.7998 16.3115 3.33041 14.8547 3.33173C13.11 3.33041 11.3537 4.00001 10.022 5.33422C9.06909 6.28458 8.4567 7.45139 8.18299 8.67672C8.17966 8.6917 8.17802 8.70674 8.1738 8.71927C8.16298 8.76684 8.15379 8.81481 8.14466 8.8603C8.12792 8.94873 8.11294 9.03678 8.09877 9.12477C8.08959 9.17777 8.08209 9.23327 8.07624 9.28621C8.06541 9.36677 8.05623 9.44934 8.04955 9.53192C8.0454 9.5795 8.04037 9.62751 8.03791 9.67504C8.03627 9.69883 8.03457 9.723 8.03293 9.74848C8.02872 9.79644 8.02708 9.84566 8.02538 9.89319C8.02205 9.98331 8.01953 10.0751 8.01953 10.1652C8.01953 10.2349 8.02205 10.3045 8.02374 10.3759C8.02708 10.446 8.03129 10.5152 8.03457 10.587L8.0454 10.7413C8.0454 10.7668 8.04955 10.7926 8.0512 10.8202C8.19809 12.3446 8.85636 13.8348 10.022 14.9983C10.7279 15.7047 11.5539 16.2253 12.4325 16.5578C12.6986 16.2645 12.9156 15.9249 13.0716 15.5595C13.2326 15.1761 13.3244 14.7705 13.3428 14.3521C12.7462 14.1377 12.1889 13.7927 11.7083 13.3121C11.2735 12.8753 10.9482 12.3759 10.732 11.8402C10.5777 11.4618 10.4784 11.0655 10.435 10.6658C10.4066 10.4292 10.4 10.1906 10.4108 9.95411C10.4141 9.89527 10.4183 9.83855 10.4216 9.78141C10.4258 9.7393 10.4291 9.69713 10.4366 9.65459C10.4366 9.63829 10.4399 9.62205 10.4416 9.60537C10.4458 9.5649 10.4508 9.52279 10.4583 9.4827C10.4675 9.42763 10.4767 9.37048 10.4875 9.31585C10.5359 9.06593 10.6052 8.82022 10.6969 8.58156C10.7137 8.53776 10.7303 8.49565 10.7504 8.45141C10.7687 8.40552 10.7887 8.35964 10.8104 8.31376C10.8288 8.26787 10.8505 8.22194 10.8747 8.17775C10.8947 8.1323 10.9188 8.08806 10.9448 8.04426C11.0657 7.81982 11.2085 7.60375 11.372 7.39802C11.4053 7.35591 11.4404 7.3138 11.4746 7.27327C11.5505 7.18692 11.6273 7.10265 11.7099 7.02007C11.8125 6.91742 11.9168 6.82188 12.0253 6.73384C12.3808 6.43847 12.7703 6.20692 13.1792 6.04215C13.981 5.7172 14.8638 5.63456 15.7057 5.79808C16.5484 5.96159 17.346 6.36464 18.0019 7.02002C18.4383 7.4568 18.7612 7.95616 18.9773 8.49144C19.3044 9.29327 19.387 10.1743 19.2235 11.0167C19.0583 11.8585 18.6544 12.6567 18.0019 13.3121C17.8584 13.4551 17.7082 13.5874 17.5522 13.7046C17.5614 13.8661 17.5664 14.0276 17.5664 14.1869C17.5689 15.0091 17.4379 15.8197 17.1867 16.5907C18.1004 16.2603 18.9573 15.7283 19.6874 14.9983C21.0199 13.6679 21.6916 11.9115 21.6899 10.1651C21.6915 8.70789 21.2218 7.24609 20.2915 6.0258L23.1851 3.13217V5.93359H25.0199V0H19.0875Z"
                                  fill="#988DAA"
                                />
                              </svg>
                            </span>
                            <span>Gender</span>
                          </div>
                          <span>{empData.gender}</span>
                        </div>
                        <div className="flex">
                          <div className="flex1">
                            <span>
                              <svg
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.4983 0C9.6668 0 7.36328 2.30352 7.36328 5.13501C7.36328 7.9665 9.6668 10.27 12.4983 10.27C15.3298 10.27 17.6333 7.9665 17.6333 5.13501C17.6333 2.30352 15.3298 0 12.4983 0ZM12.4983 7.81504C11.0205 7.81504 9.81826 6.61284 9.81826 5.13501C9.81826 3.65718 11.0205 2.45498 12.4983 2.45498C13.9761 2.45498 15.1783 3.65718 15.1783 5.13501C15.1783 6.61284 13.9761 7.81504 12.4983 7.81504Z"
                                  fill="#988DAA"
                                />
                                <path
                                  d="M12.5006 12.7251C7.31152 12.7251 3.08984 16.9468 3.08984 22.1359C3.08984 22.8138 3.63945 23.3634 4.31733 23.3634H11.2731V23.7726C11.2731 24.4504 11.8228 25 12.5006 25C13.1785 25 13.7281 24.4504 13.7281 23.7726V23.3634H20.6839C21.3618 23.3634 21.9114 22.8138 21.9114 22.1359C21.9114 16.9468 17.6897 12.7251 12.5006 12.7251ZM11.2731 20.9084H5.65327C6.16353 18.055 8.41982 15.7992 11.2731 15.2891V20.9084ZM13.7281 20.9084V15.2891C16.5815 15.7992 18.8378 18.055 19.348 20.9083H13.7281V20.9084Z"
                                  fill="#988DAA"
                                />
                              </svg>
                            </span>
                            <span>Emp Type</span>
                          </div>
                          <span>
                            {empData.isprobationsts === "0"
                              ? "Full Time"
                              : "Probation"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <CommonLeaveOverview leaveData={leaveData} year={year} />
                  </div>
                </div>
              </>
            )}
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default EmpLeaveHistory;
